import { DateInput, NumberInput, SearchInput, SelectInput } from '@/components/admin';

export const getGlobalFilters = (statusChoices: { id: string; name: string }[], statusLabel: string = "Status") => [
    <SearchInput key="q" source="q" alwaysOn className="w-64" placeholder="Search..." />,
    <SelectInput key="status" source="status" label={statusLabel} emptyText={statusLabel} choices={statusChoices} alwaysOn className="w-48" />,
    <DateInput key="date_gte" source="date@gte" label="From Date" alwaysOn className="w-40" />,
    <DateInput key="date_lte" source="date@lte" label="To Date" alwaysOn className="w-40" />,
    <NumberInput key="total_gte" source="total_amount@gte" label="Min Amount" placeholder="Min Amount" alwaysOn className="w-32" />,
    <NumberInput key="total_lte" source="total_amount@lte" label="Max Amount" placeholder="Max Amount" alwaysOn className="w-32" />,
];
